import React from "react";
import Paper from "@mui/material/Paper";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  container: {
    width: "100%",
    borderRadius: 12,
    background: theme.palette.background.paper,
    boxShadow: theme.palette.mode === "light"
      ? "0 1px 4px rgba(0,0,0,0.08)"
      : "0 1px 4px rgba(0,0,0,0.4)",
  },
  containerFlush: {
    width: "100%",
    borderRadius: 8,
    border: `1px solid ${theme.palette.divider}`,
    background: "transparent",
    boxShadow: "none",
  },
  scroll: {
    overflowX: "auto",
    overflowY: "auto",
    ...theme.scrollbarStyles,
  },
  head: {
    "& th": {
      fontWeight: 700,
      fontSize: "0.78rem",
      whiteSpace: "nowrap",
      background: theme.palette.mode === "light" ? "#f5f6f8" : "rgba(255,255,255,0.04)",
    },
  },
  empty: {
    fontSize: 13,
    color: theme.palette.text.secondary,
    fontStyle: "italic",
    padding: theme.spacing(2),
  },
  footerSlot: {
    flexShrink: 0,
    borderTop: `1px solid ${theme.palette.divider}`,
  },
}));

export const useStandardTableStyles = () => {
  const { classes } = useStyles();
  return classes;
};

export const StandardTableContainer = ({ children, maxHeight, height, flush, footer }) => {
  const classes = useStandardTableStyles();

  return (
    <Paper
      elevation={0}
      className={flush ? classes.containerFlush : classes.container}
      style={height ? { height, display: "flex", flexDirection: "column" } : undefined}
    >
      <div
        className={classes.scroll}
        style={{ ...(maxHeight ? { maxHeight } : null), ...(height ? { flex: 1, minHeight: 0 } : null) }}
      >
        {children}
      </div>
      {footer && <div className={classes.footerSlot}>{footer}</div>}
    </Paper>
  );
};

export const StandardTableEmpty = ({ label }) => {
  const classes = useStandardTableStyles();
  return <div className={classes.empty}>{label}</div>;
};
